import React from "react";
import { Quote } from "lucide-react";

const diffs = [
  "Fully sourced, vetted & packaged deals",
  "Transparent fee structure — no hidden costs",
  "Independent advice — we work for you, not agents",
  "UK-wide deal access with local market expertise",
  "Ongoing support beyond the transaction",
];

export function WhyUs() {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="bg-[var(--ivory)] py-24 lg:py-32"
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <div className="reveal bg-[var(--navy)] text-[var(--ivory)] p-10 lg:p-14 relative">
          <div className="absolute top-0 left-0 w-[2px] h-full bg-[var(--gold)]" />
          <Quote size={36} className="text-[var(--gold)] opacity-80" />
          <blockquote
            data-testid="featured-quote"
            className="mt-8 font-display text-[1.6rem] sm:text-[1.85rem] leading-[1.35] italic"
          >
            "Working with Ascend Property Group was a turning point in my investment
            journey. They found me a flip I never would have found alone — fully
            packaged, with refurb costs and resale comparables already done."
          </blockquote>
          <div className="mt-8 flex items-center gap-4">
            <div className="h-px w-10 bg-[var(--gold)]" />
            <div className="text-[0.85rem] tracking-[0.16em] uppercase text-[var(--ivory)]/75">
              James T. — Portfolio Investor
            </div>
          </div>
        </div>

        <div className="reveal">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[var(--gold-deep)]" />
            <span className="text-[0.7rem] tracking-[0.32em] uppercase text-[var(--gold-deep)]">
              Why Investors Choose Us
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.25rem] leading-[1.05] text-[var(--navy)]">
            Quiet confidence.
            <br />
            <span className="italic text-[var(--gold-deep)]">Considered counsel.</span>
          </h2>
          <ul className="mt-10 space-y-5">
            {diffs.map((d, i) => (
              <li
                key={d}
                data-testid={`differentiator-${i}`}
                className="flex items-start gap-4 text-[var(--navy)]"
              >
                <span className="mt-[10px] text-[var(--gold-deep)] text-lg leading-none">✦</span>
                <span className="text-[1.02rem] leading-relaxed">{d}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
